import { render, staticRenderFns } from "./ModalAddEditApplicant.vue?vue&type=template&id=2dfc004b&scoped=true"
import script from "./ModalAddEditApplicant.vue?vue&type=script&lang=js"
export * from "./ModalAddEditApplicant.vue?vue&type=script&lang=js"
import style0 from "./ModalAddEditApplicant.vue?vue&type=style&index=0&id=2dfc004b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfc004b",
  null
  
)

export default component.exports